import { useState } from 'react';
import { MAX_CERTIFICATION_TEXT_LENGTH } from '@dealstack/shared/lib/common/business/kycCertification';
import type { CertificationTextDraft } from './useCertificationTextDraft.types';

/**
 * DC-825: the certifier's edits to the certification wording, compared against what is stamped
 * on the document now. The saved text comes from the signing info, so a successful update
 * clears `isDirty` without syncing any state.
 */
export const useCertificationTextDraft = (
	savedText: string,
	defaultText: string
): CertificationTextDraft => {
	const [draft, setDraft] = useState(savedText);
	const [isConfirmed, setIsConfirmed] = useState(false);
	const trimmed = draft.trim();

	return {
		draft,
		setDraft,
		resetToDefault: () => setDraft(defaultText),
		isDirty: trimmed !== savedText,
		isDefault: trimmed === defaultText,
		isValid: trimmed.length > 0 && trimmed.length <= MAX_CERTIFICATION_TEXT_LENGTH,
		isConfirmed,
		setIsConfirmed,
	};
};
